import { css } from '@portal/styled-system/css'

import { useI18n } from '@/shared/lib/i18n'
import { Modal, type ModalProps } from '@/shared/ui'

import { StepOne } from './view.step-one'
import { StepTwo } from './view.step-two'

const steps = {
    step_one: StepOne,
    step_two: StepTwo,
}

export type MessageReportDialogProps = ModalProps & {
    step: 'step_one' | 'step_two'
    onReportReasonClick: (props: { reason_code: string }) => void
    onBackButtonClick: () => void
    onReportButtonClick: (props: { reason_message: string }) => void
    nonInteractive?: boolean
}

export function MessageReportDialog(props: MessageReportDialogProps) {
    const { i18n } = useI18n()

    return (
        <Modal {...props}>
            <Modal.CloseButton onClose={props.onClose} />
            <Modal.Header styles={css.raw({ backgroundColor: 'primary' })} icon="fa-solid fa-bullhorn">
                {i18n.CHAT_REPORT_TITLE}
            </Modal.Header>
            <MessageReportDialogContent {...props} />
        </Modal>
    )
}

export function MessageReportDialogContent(props: MessageReportDialogProps) {
    const Step = steps[props.step]

    return <Step {...props} />
}
